<template>
<div class="chapter">
<div class="inner_page">
<p class="default" id="d8e132NaN">
</p><p class="ct" id="d7e773"><b>FOREWORD AND DEDICATION </b></p>
<p class="tx" id="d7e823"><big><big><big><big><big><i>I</i></big></big></big></big></big> would not have spent $30,000 on college if I had known my greatest teacher would cost me $7.50. His name was Flopsy Parker. He taught me a lot of things, but his most valuable lesson was that sometimes the greatest gifts are the ones other people discard.</p>
<p class="tx" id="d7e1123">In life, people can choose their journeys. In my case, mine chose me. I walked into Guildford County shelter on a rainy Sunday afternoon with the intention of donating after seeing a newscast on rabbits that were abandoned after Easter. I left with a crazy-haired white rabbit that would lead me on the greatest journey of my life. I did not pick him that day. He picked me. </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Park_9781937084721_epub_c3_r1.vue?2996164a